import store from './store';

export const items = () => {

  if(store.state.userRole === 'admin') {
    return [
      {
        name: 'Gebruikers',
        url: '/admin/users',
        icon: 'icon-people',
      },
      {
        name: 'Mijn acties',
        url: '/admin/campaign-actions',
        icon: 'icon-energy',
      },
      {
        name: 'Nieuws',
        url: '/admin/news-articles',
        icon: 'icon-list',
      },
      {
        name: 'Chili Templates',
        url: '/admin/chili-templates',
        icon: 'icon-graph',
      },
      {
        name: 'Downloads',
        url: '/admin/downloads',
        icon: 'icon-graph',
      },
      {
        name: 'Contactpersonen',
        url: '/admin/contacts',
        icon: 'icon-graph',
      },
      {
        name: 'Voting Goals',
        url: '/admin/voting-goals',
        icon: 'icon-graph',
      },
      {
        name: 'Campagnes',
        url: '/admin/questionnaires',
        icon: 'icon-bubbles',
      },
      {
        name: 'Spiekbriefje',
        url: '/admin/cheating-letter',
        icon: 'icon-bubbles',
      },
      {
        name: 'Tips & Tricks',
        url: '/admin/tips-and-tricks',
        icon: 'icon-bubbles',
      },
      {
        name: 'Statistieken',
        url: '/admin/statistics',
        icon: 'icon-graph',
      },
    ]
  } else {
    return [
      {
        name: 'Gebruikers',
        url: '/admin/users',
        icon: 'icon-people',
      },
      {
        name: 'Mijn acties',
        url: '/admin/campaign-actions',
        icon: 'icon-energy',
      },
      {
        name: 'Statistieken',
        url: '/admin/statistics',
        icon: 'icon-graph',
      },
    ]
  }


};


